module.exports = __webpack_public_path__ + "media/images/story/typo/about-bbb6c2e81cfc7fd0cb66d3d498d48e95.svg";